<template>
  <div class="onboarding-signup-step-name">
    <VeeForm @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.NAME.@TITLE")) }}
          </h2>

          <NameForm v-model:name="form.name" :i-model="ISignup" />
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { onMounted, ref } from "vue";
  import { ISignup } from "@core/models";
  import { useTransition } from "@core/composables";
  import { useSignup } from "@etab/composables";
  import NameForm from "@etab/components/onboarding/signup/Name.component.vue";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();

  const form = ref({ name: "" });

  const onSubmit = async function () {
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step4_etab_name",
    });
    signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.etabName]: form.value.name });
    $_nextStep();
  };

  onMounted(() => {
    form.value.name = signupStore[GETTER_SIGNUP_GET][ISignup.etabName];
  });
</script>
